export default class WebsiteGenerator {
  constructor(node) {
    this.element = node;

    this.input = this.element.querySelector(".js-website-input");
    this.previewElement = this.element.querySelector(".js-website-url");
    this.defaultValue = this.previewElement.innerText;

    this.input.addEventListener("input", (e) => {
      const value = e.target.value;

      this.previewElement.innerText = value === "" ? this.defaultValue : value;
    });
  }
}
